module.exports = __webpack_public_path__ + "img/forbes.fad92436.svg";